import { MakeGenerics, Route } from '@tanstack/react-location';
import React, { lazy } from 'react';

import { AdminRouteBaseProps } from '@/layout/Admin/routes';

export type RegionsAdminRouteProps = MakeGenerics<{
  Params: {
    regionId?: string;
  };
  LoaderData: {
    regionId: string;
  };
}> &
  AdminRouteBaseProps;

const Regions = lazy(() => import('.'));
const Add = lazy(() => import('./AddRegionView'));
const Edit = lazy(() => import('./EditRegionView'));
const Redirects = lazy(() => import('./RedirectsView'));
const Collisions = lazy(() => import('./SlugCollisionsView'));
const StaleReferences = lazy(() => import('./StaleReferencesView'));
const DisabledRegions = lazy(() => import('./DisabledRegionsView'));

const RegionsAdminRoutes: Route<RegionsAdminRouteProps>[] = [
  {
    path: '/regions',
    id: 'RegionsAdmin',
    meta: {
      breadcrumbs: () => ({
        breadcrumb: 'Regioner',
      }),
    },
    children: [
      {
        path: '/',
        element: <Regions />,
      },
      {
        path: ':regionId/edit',
        id: 'RegionsAdminEdit',
        element: <Edit />,
        meta: {
          breadcrumbs: () => ({
            breadcrumb: 'Redigera',
          }),
        },
        loader: ({ params }) => ({ regionId: params.regionId }),
      },
      {
        path: '/add',
        id: 'RegionsAdminAdd',
        meta: {
          breadcrumbs: () => ({
            breadcrumb: 'Lägg till',
          }),
        },
        element: <Add />,
      },
      {
        path: '/redirects',
        id: 'RegionsAdminRedirects',
        meta: {
          breadcrumbs: () => ({
            breadcrumb: 'Omdirigeringar',
          }),
        },
        element: <Redirects />,
      },
      {
        path: '/collisions',
        id: 'RegionsAdminCollisions',
        meta: {
          breadcrumbs: () => ({
            breadcrumb: 'Slug-kollisioner',
          }),
        },
        element: <Collisions />,
      },
      {
        path: '/stale-references',
        id: 'RegionsAdminStaleReferences',
        meta: {
          breadcrumbs: () => ({
            breadcrumb: 'Föråldrade referenser',
          }),
        },
        element: <StaleReferences />,
      },
      {
        path: '/disabled',
        id: 'RegionsAdminDisabled',
        meta: {
          breadcrumbs: () => ({
            breadcrumb: 'Inaktiverade regioner',
          }),
        },
        element: <DisabledRegions />,
      },
    ],
  },
];

export const toRegionsAdmin = (): string => '/admin/regions/';
export const toRegionsAdminAdd = (): string => '/admin/regions/add';
export const toRegionsAdminEdit = (regionId: string): string =>
  `/admin/regions/${regionId}/edit`;
export const toRegionsAdminRedirects = (): string => '/admin/regions/redirects';
export const toRegionsAdminCollisions = (): string =>
  '/admin/regions/collisions';
export const toRegionsAdminStaleReferences = (): string =>
  '/admin/regions/stale-references';
export const toRegionsAdminDisabled = (): string => '/admin/regions/disabled';

export default RegionsAdminRoutes;
